import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listenProveedores } from "../../services/proveedoresService";
import "./Proveedores.css";

const ProveedoresList = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [mostrarComisionistas, setMostrarComisionistas] = useState(false);

  useEffect(() => {
    const unsub = listenProveedores({ soloActivos: false }, setItems);
    return () => unsub();
  }, []);

  // Ocultar proveedores con tipo:"comisionista" por defecto
  const filtrados = useMemo(() => {
    if (mostrarComisionistas) return items;
    return items.filter((p) => p.tipo !== "comisionista");
  }, [items, mostrarComisionistas]);

  return (
    <div className="prov-page">
      <div className="prov-panel">
        <button
          className="btn-link"
          onClick={() => navigate("/app/interna")}
          style={{ marginBottom: 12, padding: 0, background: "none", border: "none", color: "#3b82f6", cursor: "pointer", fontSize: 14 }}
        >
          ← Volver a Gestión Interna
        </button>
        <div className="prov-head">
          <div>
            <h2>Proveedores</h2>
            <p>
              Catálogo de terceros para CxP.{" "}
              {!mostrarComisionistas && items.some((p) => p.tipo === "comisionista") && (
                <span style={{ color: "#94a3b8", fontSize: 13 }}>
                  (comisionistas ocultos —{" "}
                  <button
                    style={{ background: "none", border: "none", color: "#3b82f6", cursor: "pointer", padding: 0, fontSize: 13 }}
                    onClick={() => setMostrarComisionistas(true)}
                  >
                    mostrar
                  </button>
                  )
                </span>
              )}
            </p>
          </div>
          <div className="prov-head-actions">
            <label style={{ fontSize: 13, color: "#64748b", display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={mostrarComisionistas}
                onChange={(e) => setMostrarComisionistas(e.target.checked)}
              />
              Mostrar comisionistas
            </label>
            <button className="btn btn-primary" onClick={() => navigate("/app/proveedores/nuevo")}>
              + Nuevo proveedor
            </button>
          </div>
        </div>

        <ul className="prov-grid">
          {filtrados.map(p => (
            <li key={p.id} className="prov-card">
              <div className="prov-title">
                <strong>{p.nombre || "Proveedor"}</strong>
                {!p.activo && <span className="prov-badge">Inactivo</span>}
              </div>

              <div className="prov-rows">
                {p.contacto && <div className="prov-row"><span>Contacto</span><b>{p.contacto}</b></div>}
                {p.telefono && <div className="prov-row"><span>Teléfono</span><b>{p.telefono}</b></div>}
                {p.email && <div className="prov-row"><span>Correo</span><b>{p.email}</b></div>}
                {p.rfc && <div className="prov-row"><span>RFC</span><b>{p.rfc}</b></div>}
              </div>

              <div className="prov-actions">
                <button className="btn-link" onClick={() => navigate(`/app/proveedores/${p.id}`)}>
                  Ver detalle →
                </button>
                <button
                  className="btn-link"
                  onClick={() =>
                    navigate("/app/cxp/nueva", {
                      state: { proveedorId: p.id, proveedorNombre: p.nombre || "" },
                    })
                  }
                >
                  Usar en CxP →
                </button>
              </div>
            </li>
          ))}
        </ul>

        {filtrados.length === 0 && <p className="prov-empty">No hay proveedores aún.</p>}
      </div>
    </div>
  );
};

export default ProveedoresList;
